// react
import React, { Suspense } from "react";

// components
import PageTitle from "../../../components/PageTitle";
import Spinner from "../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyEditAutoflow = React.lazy(() => import("./EditAutoflow"));

const EditAutoflowLazyLoader = () => (
	<>
		<PageTitle title="Edit Automation" />
		<Suspense fallback={<Spinner />}>
			<LazyEditAutoflow />
		</Suspense>
	</>
);

export default EditAutoflowLazyLoader;
